<template>
  <CFooter class="px-4">
    <div class="ms-auto">
      <span class="me-1">Powered by</span>
      <a href="https://itmar-solution.de" target="_blank">
        <img src="@/assets/images/logo_itmar-25.png" alt="ITMar Logo" style="height: 40px;"/>
      </a>
    </div>
  </CFooter>
</template>